import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeader";
import axios from "axios";
import Spinner from "../../../Common/Spinner";
import * as appConst from "../../../Common/constants";

class MedicineReport extends Component {
  constructor(props) {
    super(props);

    this.state = { medicine: [], spinnerClass: "", dataClass: "collapse" };
  }

  componentDidMount() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +

        "/medicine"
      )
      .then(response => {
        this.setState({
          medicine: response.data,
          spinnerClass: "collapse",
          dataClass: ""
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  tabRow() {
    return this.state.medicine.map(function (obj) {
      return (
        <tr key={obj._id}>
          <td className="border p-1">{obj.mno}</td>
          <td className="border p-1 text-wrap">{obj.name}</td>
          <td className="border p-1">{obj.qty}</td>
        </tr>
      );
    });
  }

  render() {
    return (
      <div>
        <ReportHeader onCloseClick={this.onCloseClick} IsClose="0" />
        <h3 align="center">Medicine Stock Report</h3>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid reportFont">
            <table>
              <thead>
                <tr>
                  <th className="border p-1 font-weight-bold">Medicine #</th>
                  <th className="border p-1 font-weight-bold" width="400px">
                    Name
                  </th>
                  <th className="border p-1 font-weight-bold" width="150px">
                    Stock
                  </th>
                </tr>
              </thead>
              <tbody>{this.tabRow()}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };
}

export default MedicineReport;
